import React from 'react';
import { useMsal } from '@azure/msal-react';
import { loginRequest } from '../../../auth/authConfig';
import { ImageWithBasePath } from 'Core/components';

const Signin = () => {
  const { instance } = useMsal();

  const handleLogin = () => {
    // instance.loginRedirect(loginRequest);
    const redirectUrl = process.env.REACT_APP_URI;
    window.location.href = redirectUrl;
  };

  return (
    <div className="main-wrapper">
      <div className="login-wrapper bg-img" style={{ justifyContent: 'center' }}>
        <div
          className="login-content"
          style={{
            width: '100%',
            maxWidth: '100%',
            background: 'transparent',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            padding: '20px'
          }}
        >
          <div className="login-userset" style={{
            background: 'rgba(255, 255, 255, 0.9)',
            padding: '40px',
            borderRadius: '12px',
            width: '100%',
            maxWidth: '450px',
            boxShadow: '0 4px 20px rgba(0,0,0,0.1)',
            textAlign: 'center',
            margin: 'auto'
          }}>
            <div className="login-logo logo-normal" style={{ marginBottom: '20px', display: 'flex', justifyContent: 'center' }}>
              <ImageWithBasePath src="assets/img/logo.png" alt="img" style={{ maxHeight: '60px' }} />
            </div>

            <h3 style={{ marginBottom: '30px', fontWeight: 'bold', color: '#333' }}>Chemplast</h3>

            <div className="form-login" style={{ marginBottom: '20px' }}>
              <button
                type="button"
                className="btn btn-login"
                style={{ width: '100%', padding: '12px', fontSize: '16px' }}
                onClick={handleLogin}
              >
                Sign In
              </button>
            </div>

            <div className="form-sociallink">
              <div className="d-flex justify-content-center align-items-center copyright-text">
                <p style={{ margin: 0, fontSize: '12px', color: '#666' }}>Copyright © 2019 - 2025 ChemplastInc. All Rights Reserved.</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Signin;
